export default "__VITE_ASSET__7S80lcSA__"